export default __webpack_public_path__ + "static/favicon-e38fc77b067a56407685e2362f60a70c.ico";